import { Button } from "../components/ui/button";
import { Check, Sparkles, Loader2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useState } from "react";

const PLANS = [
  { id: "free", name: "Free", usd: "$0", zar: "R0", features: ["1 scan / day","500 words / doc","1 paraphrase round","Watermarked download","Chatbot access","Last 3 documents"], cta: "Current Plan" },
  { id: "pro", name: "Pro", usd: "$9.99", zar: "R185", popular: true, features: ["Unlimited scans","10,000 words / doc","Unlimited rounds","No watermark","Plagiarism check","Full history","Priority processing","Email support"], cta: "Subscribe Now" },
  { id: "business", name: "Business", usd: "$24.99", zar: "R460", features: ["Everything in Pro","50,000 words / doc","Batch upload (10)","API access","Advanced analytics","5 team seats","White-label export","Priority chat support"], cta: "Subscribe Now" },
];

export default function Pricing() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [loading, setL] = useState(null);

  const subscribe = async (planId) => {
    if (!user) return nav("/login");
    if (planId === "free") return;
    setL(planId);
    try {
      const { data } = await api.post("/payments/lemonsqueezy/checkout", { plan: planId });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Checkout failed. Please try again.");
    } finally {
      setL(null);
    }
  };

  // PayFast — enable after business registration
  // const subscribePayFast = async (planId) => {
  //   const { data } = await api.post("/payments/initiate", { plan: planId });
  //   if (data.payfastUrl && data.payfastData) {
  //     const form = document.createElement("form");
  //     form.method = "POST"; form.action = data.payfastUrl;
  //     Object.entries(data.payfastData).forEach(([key, val]) => {
  //       const input = document.createElement("input");
  //       input.type = "hidden"; input.name = key; input.value = val;
  //       form.appendChild(input);
  //     });
  //     document.body.appendChild(form); form.submit();
  //   } else { nav(data.redirectUrl); }
  // };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14">
      <div className="text-center max-w-2xl mx-auto">
        <div className="text-xs uppercase tracking-[0.25em] text-zinc-500">Pricing</div>
        <h1 className="mt-2 text-4xl sm:text-5xl font-bold tracking-tight" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Pick your humanizing power.</h1>
        <p className="mt-3 text-zinc-400">Cancel anytime. 7-day money-back guarantee on Pro & Business.</p>
      </div>

      <div className="mt-12 grid md:grid-cols-3 gap-5">
        {PLANS.map(p => {
          const isCurrent = user?.plan === p.id;
          const isLoading = loading === p.id;
          return (
            <div key={p.id} className={`relative rounded-2xl p-7 ${p.popular ? "bg-gradient-to-br from-indigo-600/20 to-purple-600/10 border border-indigo-500/30" : "glass"}`}>
              {p.popular && <div className="absolute -top-3 left-7 text-[10px] tracking-widest uppercase bg-indigo-600 text-white px-2 py-1 rounded-full">Most Popular</div>}
              <div className="text-xs uppercase tracking-widest text-zinc-400">{p.name}</div>
              <div className="mt-2 flex items-end gap-2">
                <div className="text-4xl font-bold" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>{p.usd}</div>
                <div className="text-sm text-zinc-500 mb-1">/mo · {p.zar}</div>
              </div>
              <ul className="mt-5 space-y-2 text-sm">
                {p.features.map((f,i) => <li key={i} className="flex gap-2"><Check size={14} className="text-emerald-400 mt-0.5 flex-shrink-0"/>{f}</li>)}
              </ul>
              <Button
                disabled={isCurrent || isLoading}
                onClick={() => subscribe(p.id)}
                data-testid={`pricing-${p.id}-btn`}
                className={`mt-6 w-full ${p.popular ? "bg-indigo-600 hover:bg-indigo-700 glow-primary" : "bg-white/10 hover:bg-white/20"}`}
              >
                {isLoading ? <><Loader2 size={14} className="mr-2 animate-spin"/>Loading…</> : isCurrent ? "Current Plan" : p.cta}
              </Button>
            </div>
          );
        })}
      </div>

      <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-xs text-zinc-500">
        <span className="flex items-center gap-2"><Sparkles size={12}/>SSL secured</span>
        <span>·</span><span>Lemon Squeezy secured</span>
        <span>·</span><span>7-day refund</span>
      </div>
    </div>
  );
}
